/**
 * AntD `Form.Item normalize` for email inputs: lowercases and strips leading/
 * trailing whitespace as the admin types, so pasted `" Jane@Acme.COM "` is
 * stored as `jane@acme.com` and the `type: 'email'` rule validates the
 * cleaned value. Interior characters are left alone — a stray space inside
 * the address should still fail validation, not be silently "fixed".
 */
export function normalizeEmailInput<T extends string | undefined>(value: T): T {
  return (typeof value === 'string' ? value.trim().toLowerCase() : value) as T;
}
